<v4-custom-select
  [size]="size"
  [showTextItem]="showTextItem"
  [textItem]="textItem"
  [placeholder]="placeholder | translate"
  [(visible)]="dropdownVisible">
  <div class="v4-layout-dropdown w-[700px]">
    <v4-base-selector-body
      class="block"
      style="height: calc(100% - 60px)"
      [mode]="mode"
      [showExtra]="showDeleted"
      [showFooter]="mode === 'multi'"
      [listOfOption]="listOfData"
      [listOfExtraOption]="listOfExtraData"
      [selectedValues]="selectedValues"
      (onSelect)="onSelect($event)"
      (onConfirm)="onConfirm($event)"
      (onCancel)="onCancel()"
      (onReset)="onReset()">
      <div class="v4-base-selector-body_filters" [formGroup]="form">
        <div class="v4-filter-list overflow-x-auto mb-3" *ngIf="listOfGroupOption?.length">
          <div class="v4-filter-item">
            <div
              class="v4-filter v4-filter-selectable"
              [class.selected]="groupId === null"
              (click)="form.patchValue({ group_id: null })">
              {{ "word.group" | translate }}
              <!-- Group -->
            </div>
          </div>
          <div class="v4-filter-item" *ngFor="let group of listOfGroupOption">
            <div
              class="v4-filter v4-filter-selectable"
              [class.selected]="groupId === group.value"
              (click)="form.patchValue({ group_id: group.value })"
              style="background-color: #fff">
              {{ group.label }}
            </div>
          </div>
        </div>
        <div class="v4-filter-list overflow-x-auto mb-3" *ngIf="listOfHouseTypeOption?.length">
          <div class="v4-filter-item">
            <div
              class="v4-filter v4-filter-selectable"
              [class.selected]="roomTypeId === null"
              (click)="form.patchValue({ house_type_id: null })">
              {{ "word.house_type" | translate }}
              <!-- Room type -->
            </div>
          </div>
          <div class="v4-filter-item" *ngFor="let type of listOfHouseTypeOption">
            <div
              class="v4-filter v4-filter-selectable"
              [class.selected]="roomTypeId === type.value"
              (click)="form.patchValue({ house_type_id: type.value })"
              style="background-color: #fff">
              {{ type.label }}
            </div>
          </div>
        </div>
        <div class="v4-filter-list overflow-x-auto mb-3" *ngIf="listOfTagOption?.length">
          <div class="v4-filter-item">
            <div
              class="v4-filter v4-filter-selectable"
              [class.selected]="tagId === null"
              (click)="form.patchValue({ house_tag_id: null })">
              {{ "word.tag" | translate }}
              <!-- Tag -->
            </div>
          </div>
          <div class="v4-filter-item" *ngFor="let tag of listOfTagOption">
            <div
              class="v4-filter v4-filter-selectable"
              [class.selected]="tagId === tag.value"
              (click)="form.patchValue({ house_tag_id: tag.value })"
              style="background-color: #fff">
              {{ tag.label }}
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="v4-base-selector-body-extra">
        <div class="flex flex-row items-center cursor-pointer mb-[12px]" (click)="unfoldExtra = !unfoldExtra">
          <span>显示已删除的房间</span>
          <img class="w-[16px] ml-1" src="/assets/v4/icon-arrow-down.svg" alt="" />
        </div>
        <div class="v4-option-list" *ngIf="unfoldExtra">
          <div class="v4-option-item" (click)="onSelectOption(opt)" *ngFor="let opt of listOfExtraData">
            <div class="v4-option" [class.selected]="selectedValues?.includes(opt.value)">{{ opt.label }}</div>
          </div>
        </div>
      </div> -->
    </v4-base-selector-body>
  </div>
</v4-custom-select>
